import Axios from 'axios'
import { API_URL } from '@app/constants/endpoints'

const ENDPOINT = (id) => `${API_URL}/api/actions/${id}`

const patchAction = (accessToken, id, data) => Axios.patch(ENDPOINT(id), data, {
  headers: { 'Access-Token': accessToken },
})

export default {
  patchAction,
}
